import BenDocumentStatusIcon from "./ben-document-status-icon";

export default BenDocumentStatusIcon;
